import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid2';
import { Translate, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './image-file.reducer';

const FieldLabel = ({ children }: { children: React.ReactNode }) => (
  <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
    {children}
  </Typography>
);

const FieldValue = ({ children, sx }: { children: React.ReactNode; sx?: object }) => (
  <Typography variant="body1" sx={{ mb: 2, ...sx }}>
    {children || '-'}
  </Typography>
);

export const ImageFileDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const imageFileEntity = useAppSelector(state => state.imageFile.entity);
  return (
    <Box sx={{ maxWidth: 1200, mx: 'auto', mt: 4, p: 2 }}>
      <Box sx={{ mb: 4, display: 'flex', alignItems: 'center', gap: 2 }}>
        <h2 data-cy="imageFileDetailsHeading">
          <Translate contentKey="jhipsterSampleApplicationApp.imageFile.detail.title">ImageFile</Translate>
        </h2>
        {imageFileEntity.id && (
          <Box sx={{ bgcolor: 'primary.light', color: 'primary.contrastText', px: 2, py: 0.5, borderRadius: 1, fontWeight: 'bold' }}>
            ID: {imageFileEntity.id}
          </Box>
        )}
      </Box>

      <Grid container spacing={3}>
        <Grid size={{ xs: 12, md: 6 }}>
          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.imageFile.code" />
          </FieldLabel>
          <FieldValue>{imageFileEntity.code}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.imageFile.title" />
          </FieldLabel>
          <FieldValue>{imageFileEntity.title}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.imageFile.alt" />
          </FieldLabel>
          <FieldValue>{imageFileEntity.alt}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.imageFile.filename" />
          </FieldLabel>
          <FieldValue>{imageFileEntity.filename}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.imageFile.createdDate" />
          </FieldLabel>
          <FieldValue>
            {imageFileEntity.createdDate ? (
              <TextFormat value={imageFileEntity.createdDate} type="date" format={APP_LOCAL_DATE_FORMAT} />
            ) : null}
          </FieldValue>
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.imageFile.createdBy" />
          </FieldLabel>
          <FieldValue>{imageFileEntity.createdBy ? imageFileEntity.createdBy.login : ''}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.imageFile.destination" />
          </FieldLabel>
          <FieldValue>{imageFileEntity.destination ? imageFileEntity.destination.code : ''}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.imageFile.tour" />
          </FieldLabel>
          <FieldValue>{imageFileEntity.tour ? imageFileEntity.tour.code : ''}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.imageFile.tourCategory" />
          </FieldLabel>
          <FieldValue>{imageFileEntity.tourCategory ? imageFileEntity.tourCategory.code : ''}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.imageFile.place" />
          </FieldLabel>
          <FieldValue>{imageFileEntity.place ? imageFileEntity.place.code : ''}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.imageFile.placeCategory" />
          </FieldLabel>
          <FieldValue>{imageFileEntity.placeCategory ? imageFileEntity.placeCategory.code : ''}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.imageFile.tourExtraCategory" />
          </FieldLabel>
          <FieldValue>{imageFileEntity.tourExtraCategory ? imageFileEntity.tourExtraCategory.code : ''}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.imageFile.tourExtra" />
          </FieldLabel>
          <FieldValue>{imageFileEntity.tourExtra ? imageFileEntity.tourExtra.code : ''}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.imageFile.vehicle" />
          </FieldLabel>
          <FieldValue>{imageFileEntity.vehicle ? imageFileEntity.vehicle.plate : ''}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.imageFile.driver" />
          </FieldLabel>
          <FieldValue>{imageFileEntity.driver ? imageFileEntity.driver.name : ''}</FieldValue>
        </Grid>

        <Grid size={12}>
          <Box sx={{ display: 'flex', gap: 2, mt: 3 }}>
            <Button
              component={Link}
              to="/image-file"
              replace
              color="info"
              variant="outlined"
              startIcon={<FontAwesomeIcon icon="arrow-left" />}
            >
              <Translate contentKey="entity.action.back">Back</Translate>
            </Button>
            <Button
              component={Link}
              to={`/image-file/${imageFileEntity.id}/edit`}
              replace
              color="primary"
              variant="contained"
              startIcon={<FontAwesomeIcon icon="pencil-alt" />}
            >
              <Translate contentKey="entity.action.edit">Edit</Translate>
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ImageFileDetail;
